__turbopack_context__.v({
  "caption": "aKDC4a_caption",
  "container": "aKDC4a_container",
  "content": "aKDC4a_content",
  "icons": "aKDC4a_icons",
  "seeAllButton": "aKDC4a_seeAllButton",
});
